import _ from 'lodash'
import config from '../config'

export const state = () => {
  // default values
  return {
    current: null,

    isRunningTutorial: false,
    currentTutorialStep: -1,
    isShowTutorial: true,

    isComputing: false,
    result: null
  }
}

const INIT_DISCIPLINE = 'initDiscipline'
const ADD_SELECTED_SKILL = 'addSelectedSkill'
const REMOVE_SELECTED_SKILL = 'removeSelectedSkill'
const RESET_SKILLS = 'resetSkills'
const SET_RUN_TUTORIAL = 'setRunTutorial'
const SET_CURRENT_STEP = 'setCurrentStep'
const SET_IS_SHOW_TUTORIAL = 'setIsShowTutorial'
const SET_IS_COMPUTING = 'setIsComputing'
const SET_SKILLSVUE_RESULT = 'setSkillsVueResult'

export const mutations = {
  [INIT_DISCIPLINE]: (state, discipline) => {
    discipline.core_skills = discipline.top_prevalent_skills.filter(
      (s) => s.is_core
    )
    discipline.selected_skills = _.clone(discipline.core_skills)
    state.current = discipline
    state.result = null
  },
  [ADD_SELECTED_SKILL]: (state, skill) => {
    state.current.selected_skills.push(skill)
  },
  [REMOVE_SELECTED_SKILL]: (state, skill) => {
    const index = _.indexOf(state.current.selected_skills, skill)
    state.current.selected_skills.splice(index, 1)
  },
  [RESET_SKILLS]: (state) => {
    state.current.selected_skills = _.clone(state.current.core_skills)
  },

  [SET_RUN_TUTORIAL]: (state, bool) => {
    state.isRunningTutorial = bool
  },

  [SET_CURRENT_STEP]: (state, stepNum) => {
    state.currentTutorialStep = stepNum
  },

  [SET_IS_SHOW_TUTORIAL]: (state, bool) => {
    state.isShowTutorial = bool
  },

  [SET_IS_COMPUTING]: (state, bool) => {
    state.isComputing = bool
  },

  [SET_SKILLSVUE_RESULT]: (state, result) => {
    state.result = result
  }
}

export const actions = {
  init: function({ commit }, discipline) {
    commit(INIT_DISCIPLINE, discipline)
  },

  resetSkills: ({ commit }) => {
    commit(RESET_SKILLS)
  },

  addSelectedSkill: ({ commit }, skill) => {
    commit(ADD_SELECTED_SKILL, skill)
  },

  removeSelectedSkill: ({ commit }, skill) => {
    commit(REMOVE_SELECTED_SKILL, skill)
  },

  setRunTutorial: ({ commit }, bool) => {
    commit(SET_RUN_TUTORIAL, bool)
  },

  setCurrentStep: ({ commit }, stepNum) => {
    commit(SET_CURRENT_STEP, stepNum)
  },

  setIsShowTutorial: ({ commit }, bool) => {
    commit(SET_IS_SHOW_TUTORIAL, bool)
  },

  setIsComputing: ({ commit }, bool) => {
    commit(SET_IS_COMPUTING, bool)
  },

  setSkillsVueResult: ({ commit }, result) => {
    commit(SET_SKILLSVUE_RESULT, result)
  }
}

export const getters = {
  getSelectedSkills: (state) => () => {
    return state.current.selected_skills || []
  },

  getPrevalentSkills: (state) => () => {
    return state.current.top_prevalent_skills || []
  },

  getSuggestedSkills: (state) => () => {
    return _.clone(state.current.top_prevalent_skills || [])
      .filter((a) => a.order)
      .sort((a, b) => {
        return a.order - b.order
      })
  },

  getCoreSkills: (state) => () => {
    return state.current.core_skills || []
  },

  isOnlyAllCoreSkillSelected: (state, getters) => () => {
    const coreSkills = getters.getCoreSkills()
    const selectedSkills = getters.getSelectedSkills()
    return _.isEqual(_.clone(coreSkills).sort(), _.clone(selectedSkills).sort())
  },

  getAvaiableQuantiles: (state) => () => {
    const percentiles = config.percentiles
    return _.compact(percentiles.filter((p) => state.current[p.code] !== null))
  },

  getBaseSalary: (state) => (percentileCode) => {
    return state.current[percentileCode]
  },

  getProjectedSalary: (state) => (percentileCode) => {
    if (state.result === null) {
      return -1
    }
    return state.result[percentileCode]
  },

  getConfidence: (state) => () => {
    if (state.result === null) {
      return -1
    }
    return state.result.confidence
  },

  getContributingCompanies: (state) => () => {
    return state.current.top_companies
  }
}
